export default __webpack_public_path__ + "static/media/narfBuilding.0dd9fb6d.jpeg";